// App.js
import React from 'react';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import { Box } from '@mui/material';
import ExerciseDetail from './client/pages/ExerciseDetail';
import Home from './client/pages/Home';
import Navbar from './client/Navbar';
import Footer from './client/Footer';
import Timer from './client/pages/Timer';
import WeightTracker from './client/pages/WeightTracker';
import Programs from './client/pages/Programs';
import Gallery from './client/pages/Gallery';
import FoodTrack from './client/pages/FoodTrack';
import Ad from './client/pages/Ad';
import ChatAi from './client/pages/ChatAi';
import Recipes from './client/pages/Recipes';
import Crawler from './client/pages/Crawler';
import SelectRole from './client/pages/SelectRole';
import TrainerHunt from './client/pages/TrainerHunt';
import Portal from './client/pages/Portal';
import Workout from './client/pages/Workout';
import EditStartWorkout from './client/pages/EditStartWorkout';
import StartWorkout from './client/pages/StartWorkout';
import Brand from './client/pages/Brand';
import NutritionPlans from './client/pages/NutritionPlans';
import StartNutritionPlan from './client/pages/StartNutritionPlan';

const App = () => {
  const userId = localStorage.getItem('userId');

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Navbar />
      <Box sx={{ flexGrow: 1 }}>
        <Routes>
          <Route path="/" element={<Home userId={userId} />} />
          <Route path="/exercise/:id" element={<ExerciseDetail />} />
          <Route path="/timer" element={<Timer />} />
          <Route path="/weight" element={<WeightTracker userId={userId} />} />
          <Route path="/program" element={<Programs userId={userId} />} />
          <Route path="/foodTrack" element={<FoodTrack userId={userId} />} />
          <Route path="/gallery" element={<Gallery userId={userId} />} />
          <Route path="/adminAd" element={<Ad userId={userId} />} />
          <Route path="/chat" element={<ChatAi />} />
          <Route path="/recipes" element={<Recipes />} />
          <Route path="/crawl" element={<Crawler />} />
          <Route path="/select-role" element={<SelectRole />} />
          <Route path="/hunt" element={<TrainerHunt userId={userId} />} />
          <Route path="/portal" element={<Portal userId={userId} />} />
          <Route path="/workoutProgram" element={<Workout userId={userId} />} />
          <Route path="/edit-program/:programId" element={<EditStartWorkout userId={userId} />} />
          <Route path="/start-workout/:programId" element={<StartWorkout userId={userId} />} />
          <Route path="/brand" element={<Brand />} />
          <Route path="/nutrition" element={<NutritionPlans userId={userId} />} />
          <Route path="/start-nutrition/:planId" element={<StartNutritionPlan userId={userId} />} />
        </Routes>
      </Box>
      <Footer userId={userId} />
    </Box>
  );
};

export default App;